import { SvgIcon } from '@mui/material'

interface TedToolsLogoProps {
  size?: number
  isActive?: boolean
}

const TedToolsLogo = ({ size = 22, isActive }: TedToolsLogoProps) => {
  return (
    <SvgIcon
      sx={{
        fontSize: size ?? 22,
        filter: isActive ? 'grayscale(0%)' : 'grayscale(100%)',
        transition: 'filter 0.2s ease',
        flexShrink: 0,
        '&:hover': {
          backgroundColor: 'transparent',
          transform: 'scale(1.15)',
          filter: 'grayscale(0%)',
        },
      }}
      viewBox="0 0 24 24"
    >
      <rect x="9" y="0" width="6" height="6" rx="1.5" fill="#43A047" />
      <rect x="0" y="13.5" width="6" height="6" rx="1.5" fill="#0066DC" />
      <rect x="9" y="9" width="6" height="6" rx="1.5" fill="#FFB703" />
      <rect x="18" y="4.5" width="6" height="6" rx="1.5" fill="#1D4E89" />
      <rect x="9" y="18" width="6" height="6" rx="1.5" fill="#F29112" />
    </SvgIcon>
  )
}

export default TedToolsLogo
